import { render, staticRenderFns } from "./OrderProducts.vue?vue&type=template&id=0c89f38a&"
import script from "./OrderProducts.vue?vue&type=script&lang=ts&"
export * from "./OrderProducts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports